export const customTheme = { token: { colorPrimary: '#dec407', fontFamily: 'Montserrat' } };
